import { createFileRoute } from '@tanstack/react-router';
import { EmailWorkspace } from '@/components/email-generation/EmailWorkspace';
import { useSyncTenantFromParams } from '@/context/organization-context';

interface ChatSearch {
  /** In-app path the editor's Back button returns to (e.g. the flow that created this email). */
  returnTo?: string;
}

export const Route = createFileRoute(
  '/_authed/dashboard_/o/$orgId/c/$clientId/emails/$templateId/chat',
)({
  component: ChatPage,
  validateSearch: (search: Record<string, unknown>): ChatSearch => ({
    returnTo: typeof search.returnTo === 'string' ? search.returnTo : undefined,
  }),
});

function ChatPage() {
  const { orgId, clientId, templateId } = Route.useParams();
  useSyncTenantFromParams(orgId, clientId);
  return <EmailWorkspace templateId={templateId} currentRoute="chat" />;
}
